import React from 'react';
import { getHeader, getExplore, getRoute, getIdentity, getContactInfo, getPriceTable } from 'src/api';
import { translationsParser } from 'src/config/translations/translationsParser';
import { Layout } from 'src/components/routes';

export async function getServerSideProps(context) {
  const { params } = context;
  const headerApi = getHeader(context.req.headers);
  const exploreApi = getExplore(context.req.headers);
  const identityApi = getIdentity(context.req.headers);
  const contactInfoApi = getContactInfo(context.req.headers);
  const plansApi = getPriceTable(context.req.headers);
  try {
    const [header, explore, identity, route, contact, plans] = await Promise.all([
      headerApi,
      exploreApi,
      identityApi,
      getRoute(params.slug),
      contactInfoApi,
      plansApi,
    ]);

    const material = route.data.data.steps[0].courses[0];
    return {
      props: {
        preloadedState: {
          initialState: {
            header: header.data,
            explore: explore.data.data,
            identity: identity.data,
            plans: plans?.data?.data ?? {},
            route: {
              ...route.data.data,
              material_data: {
                material_url: material.actual_material.url,
                thumbnail: material.actual_material.thumbnail,
                name: material.title,
                badge_url: material.badge_url,
                course_title: material.actual_material.title,
              }
            },
            contactInfo: contact.data,
          },
          i18n: translationsParser('ruta', params.locale),
          metatags: {
            MetaTitle: route?.data?.data?.seo_title || route.data.metadata.meta_title,
            MetaDescription: route.data.metadata.meta_description,
            image: route.data.metadata.image,
            canonical: `${header.data.canonical}/ruta/${params.slug}/`,
          },
        },
      },
    };
  } catch (error) {
    return {
      redirect: {
        destination: `/`,
        permanent: false,
      },
    };
  }
}

const AddPredictor = () => {
  return <Layout />;
};

export default AddPredictor;
